import { Card, CardContent, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";


export const Products: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate()
  const products = [
    {
      title: "GST Registration",
      desc: "Get exclusive pricing for assisted GST registration services, starting at Rs.299",
      logo: "https://via.placeholder.com/40",
      path: "/gst-registration",
    },
    {
      title: "GST Returns Filing by Experts",
      desc: "Get an experienced accountant to file your monthly GST returns. Starting at Rs. 2,999 p.a only!",
      logo: "https://via.placeholder.com/40",
      path: "/gst-return",
    },
    {
      title: "Telecalling CRM",
      desc: "A full-featured Dialer and Telecalling CRM to upgrade productivity and supercharge sales",
      logo: "https://via.placeholder.com/40",
      path: "/telecalling",
    },
    {
      title: "Create an Advanced Online Store",
      desc: "Create a high-speed e-commerce website with built-in SEO and seamless checkout",
      logo: "https://via.placeholder.com/40",
      path: "",
    },
    {
      title: "Get Vyapar Assured Thermal Printers",
      desc: "Built to work flawlessly with Vyapar. Price starting just @₹2999. Grab yours today!",
      logo: "https://via.placeholder.com/40",
      path: "",

    },
  ];

  return (
    <>
      {/* Main Content */}
      <Grid component="main" sx={{ flexGrow: 1, p: 3 }}>


        {/* Products */}
        <Typography variant="h6" mt={3} mb={2}>
          Products for you
        </Typography>
        <Grid container spacing={2}>
          {products.map((item, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card sx={{ display: "flex", alignItems: "center", p: 2, borderRadius: 2 }}>
                <img src={item.logo} alt={item.title} style={{ width: 50, height: 50, marginRight: 16 }} />
                <CardContent sx={{ flex: 1 }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.desc}
                  </Typography>
                </CardContent>
                <IconButton onClick={() => navigate(item.path)}>
                  <ArrowForwardIosIcon fontSize="small" />
                </IconButton>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  )
})